// prepareAnswer 对某些问题预制答案

export default [
  // { matter: 'xxx', answer: 'xxxxxx' },
  { matter: '你好', answer: '你好，请问有什么可以帮你的吗？' },
  { matter: 'hello', answer: 'Hello, may I help you?' },
  { matter: '你是谁', answer: '我是在啊客服！' },
  { matter: 'who you are', answer: "I am 'Here' customer service!" },
  { matter: ['今天是几号', '今天是什么日子'], answer: function() {
    const time = new Date();
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    return '今天是' + y + '年' + m + '月' + d + '日';
  } },
  { matter: ['现在是几点', '现在是什么时间'], answer: function() {
    const time = new Date();
    const h = time.getHours();
    const m = time.getMinutes();
    const t = h < 8 ? '早上' : h < 12 ? '上午' : h < 13 ? '中午' : h < 19 ? '下午' : '晚上';
    return '现在是' + t + (h < 13 ? h : (h - 12)) + '点' + m + '分';
  } }
]
